(function(angular){
	'use strict';

	angular
		.module('serviceLevelModule')
		.factory('ServiceLevelFactory', [
			'$q',
			'Big',
			'InvestmentEntityFactory',
			'INVESTMENT_ENTITY_ID',
			'urlFactory',
			serviceLevelFactoryFunction
		]);

	function serviceLevelFactoryFunction(
		$q,
		Big,
		InvestmentEntityFactory,
		INVESTMENT_ENTITY_ID,
		urlFactory) {

		var factory = {
			getAvailableRiaPlans: getAvailableRiaPlans,
			getCurrentServiceLevel: getCurrentServiceLevel,
			getIsAboveUpgradeThreshold: getIsAboveUpgradeThreshold,
			getIsAboveUpgradeCommunicationThreshold: getIsAboveUpgradeCommunicationThreshold,
			getNextServiceLevel: getNextServiceLevel,
			getRiaPlanByStrategyAndType: getRiaPlanByStrategyAndType,
			updatePlan: updatePlan,
			upgradeServiceLevelAndRiaPlan: upgradeServiceLevelAndRiaPlan
		};

		function getAvailableRiaPlans(serviceLevel, isIra) {
			var url = '/api/service-level/' + serviceLevel + '/ria-plans?ira=' + isIra;

			return urlFactory.apiGetPromise(url)
				.then(function(response) {
					return response.data;
				});
		}

		function getCurrentServiceLevel() {
			var deferred = $q.defer();

			InvestmentEntityFactory.getEntityOverview()
				.then(function(entityOverview) {
					deferred.resolve(entityOverview.currentServiceLevel);
				})
				.catch(function(response) {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function getNextServiceLevel() {
			var deferred = $q.defer();

			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/next-service-level';

			urlFactory.apiGetPromise(url)
				.then(function(response) {
					var data = response.data;
					if(angular.isDefined(data.name)) {
						data.amountNeededToUpgrade = parseInt(new Big(response.data.amountNeededToUpgrade).toFixed(0));
						data.isAboveUpgradeThreshold = getIsAboveUpgradeThreshold(data.principalInvestedToDate, data.upgradeThreshold);
						deferred.resolve(data);
					} else {
						deferred.resolve(undefined);
					}
				})
				.catch(function(response) {
					deferred.reject(response);
				});

			return deferred.promise;		
		}

		function getRiaPlanByStrategyAndType(investmentStrategy, planType) {
			var url = '/api/ria/investment-strategy/' + investmentStrategy + '/plan-type/' + planType;
			return urlFactory.apiGetPromise(url)
				.then(function(response) {
					return response.data.id;
				});
		}

		function getIsAboveUpgradeCommunicationThreshold(principalInvestedToDate, upgradeCommunicationThreshold, additionalInvestmentAmount) {

			var isAboveUpgradeCommunicationThreshold;
			principalInvestedToDate = new Big(principalInvestedToDate);
			upgradeCommunicationThreshold = new Big(upgradeCommunicationThreshold);

			if(angular.isDefined(additionalInvestmentAmount)) {
				additionalInvestmentAmount = new Big(additionalInvestmentAmount);
				isAboveUpgradeCommunicationThreshold = principalInvestedToDate.plus(additionalInvestmentAmount).gte(upgradeCommunicationThreshold);
			} else {
				isAboveUpgradeCommunicationThreshold = principalInvestedToDate.gte(upgradeCommunicationThreshold);
			}
			return isAboveUpgradeCommunicationThreshold;
		}

		function getIsAboveUpgradeThreshold(principalInvestedToDate, upgradeThreshold, additionalInvestmentAmount) {
			
			var isAboveUpgradeThreshold;
			principalInvestedToDate = new Big(principalInvestedToDate);
			upgradeThreshold = new Big(upgradeThreshold);
			
			if(angular.isDefined(additionalInvestmentAmount)) {
				additionalInvestmentAmount = new Big(additionalInvestmentAmount);
				isAboveUpgradeThreshold = principalInvestedToDate.plus(additionalInvestmentAmount).gte(upgradeThreshold);
			} else {
				isAboveUpgradeThreshold = principalInvestedToDate.gte(upgradeThreshold);
			}
			return isAboveUpgradeThreshold;
		}

		function updatePlan(riaPlanId){
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/ria-plan/' + riaPlanId + '/update';

			return urlFactory.apiPostPromise(url)
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					return $q.reject();
				});
		}

		function upgradeServiceLevelAndRiaPlan(serviceLevel, riaPlanId){
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/service-level/upgrade';

			var requestBody = {
				'serviceLevel': serviceLevel,
				'riaPlanId': riaPlanId
			};

			return urlFactory.apiPostPromise(url, requestBody)
				.then(function(response) {
					return response.data;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					return $q.reject();
				});
		}

		return factory;
	}
})(window.angular);